import React from 'react';
import Icon from '@gumtree/ui-library/src/icon/icon';

const SellerStatsBlock = ({ icon, message, value, strong, className }: SellerStatsBlockProps) => (
    <div className={`seller-stats-item ${className}`}>
        {icon && (
            <span className="seller-stats-icon">
                <Icon type={icon} color="grey" size="small" />
            </span>
        )}
        <p className={`seller-stats-text ${className}`}>
            {message}
            {strong ? (
                <strong className="seller-stats-emphasis"> {value}</strong>
            ) : (
                <span> {value}</span>
            )}
        </p>
    </div>
);

SellerStatsBlock.defaultProps = {
    strong: true,
    className: '',
    icon: '',
};

interface SellerStatsBlockProps {
    className?: string,
    icon?: string,
    message: string,
    strong?: boolean,
    value: string,
};

export default SellerStatsBlock;
